import {apiFetch} from "../client";

// ─── Двухфакторный вход (admin) ───────────────────────────────
// Источник правды по телам: internal/sso/second_factor.go + oapi-spec.yml.
// Код включает и перевыпускает админ; QR и ключ приходят один раз в ответе
// выпуска и больше нигде не хранятся на клиенте.

/** Сколько суток действует вход с 2FA, если админ не задал другое; допустимо от 1 до 90. */
export const SECOND_FACTOR_DEFAULT_SESSION_DAYS = 7;
export const SECOND_FACTOR_MAX_SESSION_DAYS = 90;

export interface SecondFactorStatus {
    enabled: boolean;
    issuedAt?: string;
    /** Сколько суток действует вход с 2FA; есть, пока 2FA включена. */
    sessionDays?: number;
}

/** Ответ выпуска: показать админу один раз и забыть. */
export interface SecondFactorEnrollment {
    userId: string;
    login: string;
    secret: string;
    otpauthUri: string;
    /** PNG QR-кода как data URL. */
    qrCode: string;
    issuedAt: string;
    sessionDays: number;
}

export interface AdminUserItem {
    userId: string;
    login: string;
    isActive: boolean;
    secondFactor: SecondFactorStatus;
}

export interface ListAdminsResponse {
    items: AdminUserItem[];
}

/** POST /v1/admin/users/{id}/second-factor — включить или выпустить заново; старый ключ и сессии гаснут. */
export function issueSecondFactor(token: string | null, userId: string, sessionDays: number): Promise<SecondFactorEnrollment> {
    return apiFetch<SecondFactorEnrollment>(`/admin/users/${encodeURIComponent(userId)}/second-factor`, token, {
        method: "POST",
        body: JSON.stringify({sessionDays}),
    });
}

/** PATCH /v1/admin/users/{id}/second-factor — срок входа со следующего входа; QR прежний. */
export function setSecondFactorSessionDays(token: string | null, userId: string, sessionDays: number): Promise<SecondFactorStatus> {
    return apiFetch<SecondFactorStatus>(`/admin/users/${encodeURIComponent(userId)}/second-factor`, token, {
        method: "PATCH",
        body: JSON.stringify({sessionDays}),
    });
}

/** DELETE /v1/admin/users/{id}/second-factor — выключить, дальше вход по паролю. */
export function disableSecondFactor(token: string | null, userId: string): Promise<SecondFactorStatus> {
    return apiFetch<SecondFactorStatus>(`/admin/users/${encodeURIComponent(userId)}/second-factor`, token, {
        method: "DELETE",
    });
}

/** GET /v1/admin/admins — админы со статусом кода. */
export function listAdmins(token: string | null): Promise<ListAdminsResponse> {
    return apiFetch<ListAdminsResponse>("/admin/admins", token);
}
